
export const USER_INFO = "USER_INFO";
export const ERROR = "ERROR";
export const GET_SELECTED_MENU = "GET_SELECTED_MENU";
export const SUCCESS = "SUCCESS";
export const GET_TECHNOLOGIES = "GET_TECHNOLOGIES";
